<template>
  <SideMenuLayout title="Clients" :items="items">
    <slot/>
  </SideMenuLayout>
</template>

<script>
import {CLIENT_TABS} from "@/components/clientTabs";
import SideMenuLayout from "@/components/SideMenuLayout.vue";

/**
 * Menu latéral des clients (Prospection, Acquis, Non intéressés) ; le contenu de la page se place à l'intérieur.
 * currentTab : clé de la rubrique affichée (absente quand le tableau est ouvert sans rubrique, ex. fiche d'un client précis).
 */
export default {
  name: "ClientsHeader",
  components: {SideMenuLayout},
  props: {
    currentTab: {type: String, default: undefined},
  },
  computed: {
    items() {
      return CLIENT_TABS.map(tab => ({to: tab.path, label: tab.label, icon: tab.icon, active: tab.key === this.currentTab}));
    }
  }
};
</script>
